import { ServiceLanguage } from "@albertine/i18n";
import { z } from "zod";
import { LoginSentinelValue, Name } from "../login";
import { MembershipStagePaidExposedToMember } from "../membership.firestore";
import {
    Email,
    FirebaseId,
    MemberId,
    PhoneNumber,
    ShortString,
    VeryShortString,
} from "../primitives";
import { Contributions, FirebaseTimestamp } from "../record.firestore";

export const MemberDocSchema = z.object({
    title: VeryShortString.optional().nullable(),
    firstName: Name,
    lastName: Name,
    phoneNumber: PhoneNumber.or(LoginSentinelValue.phoneNumber),
    email: Email.or(LoginSentinelValue.email),

    conversation: FirebaseId,
    createdAt: FirebaseTimestamp,
    updatedAt: FirebaseTimestamp.nullable().optional(),

    contributions: Contributions.optional().nullable(),
    referralId: z.string().optional().nullable(),

    hasVisitedChat: z.boolean().optional(),
    hasSeenChatPopover: z.boolean().nullish(),

    agentFirstName: ShortString.optional().nullable(),
    assignedToName: ShortString.optional().nullable(),

    greetingsName: z.string().optional().nullable(),

    hasOnboardingShown: z.boolean().optional().nullable(),
    hasUsedQuickActionPlaceRequest: z.boolean().optional().nullable(),
    hasUsedQuickActionOnboardingCall: z.boolean().optional().nullable(),

    membership: MembershipStagePaidExposedToMember.or(z.undefined()).nullable(),

    serviceLanguage: ServiceLanguage.optional().nullable(),
});

export type MemberDoc = z.infer<typeof MemberDocSchema>;

export const MemberSchema = MemberDocSchema.and(
    z.object({
        id: MemberId,
    }),
);

export type Member = z.infer<typeof MemberSchema>;
